import { useState } from 'react';
import { ChefHat, Sparkles, Timer, Users2, Medal } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import CookingTimer from './CookingTimer';

export default function FloatingFAB({ onOpenCommunity, onOpenLearning, onOpenCerts }) {
  const [open, setOpen] = useState(false);
  const [timerOpen, setTimerOpen] = useState(false);
  const toggle = () => setOpen(!open);

  // 🔥 ANDROID BACK BUTTON INTEGRATION
  // Expose global close function so native back button can collapse the FAB menu
  window.closeFABMenu = () => {
    setOpen(false);
  };

  return (
    <div
      className="
        fixed 
        bottom-[calc(1rem+env(safe-area-inset-bottom))] 
        right-4 
        z-50 flex flex-col items-end gap-3
      "
    >
      <AnimatePresence>
        {open && (
          <motion.div
            className="flex flex-col items-end gap-2"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ type: 'spring', stiffness: 400, damping: 20 }}
          >
            <FABTool
              label="Community"
              icon={<Users2 className="w-5 h-5" />}
              onClick={() => {
                onOpenCommunity();
                toggle();
              }}
            />
            <FABTool
              label="Learn"
              icon={<Sparkles className="w-5 h-5" />}
              onClick={() => {
                onOpenLearning();
                toggle();
              }}
            />
            <FABTool
              label="Badges"
              icon={<Medal className="w-5 h-5" />}
              onClick={() => {
                onOpenCerts();
                toggle();
              }}
            />
            <FABTool
              label="Timer"
              icon={<Timer className="w-5 h-5" />}
              onClick={() => {
                setTimerOpen(true);
                setOpen(false);
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={toggle}
        aria-label="Open Tools"
        className="
          flex items-center justify-center 
          w-14 h-14        /* 56px safe touch */
          bg-rich-gold text-white 
          rounded-full shadow-lg 
          hover:scale-105 transition-transform 
          touch-none
        "
      >
        <ChefHat className="w-6 h-6" />
      </button>

      <CookingTimer isOpen={timerOpen} onClose={() => setTimerOpen(false)} />
    </div>
  );
}

function FABTool({ label, icon, onClick }) {
  return (
    <button
      onClick={onClick}
      className="
        flex items-center gap-3
        px-4 py-3
        min-h-[44px]           /* required touch size */
        bg-white text-gray-800 
        rounded-lg shadow-md 
        text-base hover:bg-yellow-100 
        transition-colors
      "
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}
